<template>
  <div class="header">
    <div class="header-left">
      <span>苏州旅游团队电子行程单服务平台</span>
    </div>
    <div class="header-right">
      <el-dropdown placement="bottom-end" v-on:command="handleCommand">
        <el-row>
          <i class="el-icon-user"></i>
          <span class="uname">{{ uname }}</span>
          <i class="el-icon-caret-bottom"></i>
        </el-row>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
          <el-dropdown-item command="openLoginerInfo">修改企业信息</el-dropdown-item>
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div>
        <el-dialog
          title="修改企业信息"
          @closed="closeDialog('addformRef')"
          :visible.sync="adddialogVisible"
          :close-on-click-modal="false"
          append-to-body
          width="40%"
        >
          <el-form :model="Data.company" status-icon :rules="rules" ref="addformRef" label-width="140px">
            <el-form-item prop="Name" label="企业名称">
              <el-input v-model="Data.company.Name" placeholder="请输入企业名称" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item prop="RegistCode" label="社会统一信用代码">
              <el-input v-model="Data.company.RegistCode" placeholder="请输入社会统一信用代码"></el-input>
            </el-form-item>-->

            <el-form-item prop="Fax" label="传真">
              <el-input v-model="Data.company.Fax" placeholder="请输入传真"></el-input>
            </el-form-item>
            <el-form-item prop="PostCode" label="邮编">
              <el-input v-model="Data.company.PostCode" placeholder="请输入邮编"></el-input>
            </el-form-item>
            <el-form-item prop="Email" label="邮箱">
              <el-input v-model="Data.company.Email" type="Email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item prop="Tel1" label="联系人手机号">
              <el-input v-model="Data.company.Tel1" placeholder="请输入客服电话"></el-input>
            </el-form-item>
            <el-form-item prop="ServiceTel" label="客服电话">
              <el-input v-model="Data.company.ServiceTel" placeholder="请输入客服电话"></el-input>
            </el-form-item>
            <el-form-item prop="Address" label="地址">
              <el-input v-model="Data.company.Address" placeholder="请输入地址"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="adddialogVisible = false">取 消</el-button>

            <el-button type="primary" @click="postModel">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>

    <el-dialog
      title="修改密码"
      :visible.sync="updpasdialogVisible"
      @closed="closeDialog('updpasformRef')"
       :close-on-click-modal="false"
      append-to-body
      width="30%"
    >
      <el-form :model="updFormpas" status-icon ref="updpasformRef" :rules="updpasformrules" label-width="100px">
        <el-form-item label="原密码" prop="OldPassword">
          <el-input v-model="updFormpas.OldPassword" :type="pwdType1"  placeholder="请输入原密码">
            <i slot="suffix" id="PassView1" class="el-icon-view" @click="showPwd1"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="NewPassword">
          <el-input v-model="updFormpas.NewPassword" :type="pwdType2"  placeholder="包含8位及以上的数字、大小写字母及特殊符合">
            <i slot="suffix" id="PassView2" class="el-icon-view" @click="showPwd2"></i>
          </el-input>
        </el-form-item>

        <!-- 密码强度提示 -->
        <el-form-item>
          <div id="tips" v-if="updFormpas.NewPassword.length>0"><span></span><span></span><span></span><span></span></div>
        </el-form-item>

        <el-form-item label="确认密码" prop="chickPassword">
          <el-input v-model="updFormpas.chickPassword" :type="pwdType3" placeholder="请再次确认密码">
            <i slot="suffix" id="PassView3" class="el-icon-view" @click="showPwd3"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updpasdialogVisible = false">取 消</el-button>

        <el-button type="primary" @click="changepas('updpasformRef')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery'
import { validatePhone,validatePhoneTwo } from "../common/element-validator";
import { removeToken } from '../common/auth'
import UPDATUSER from '../api/user'
import { validatePassword,validatePasswordNew } from '../common/element-validator'
export default {
  name: 'Header',
  data() {
    var reCheckPassword = (rule, value, callback) => {
      if (value === '') {
          callback(new Error('请再次确认密码!'));
      } else if (value !== this.updFormpas.NewPassword) {
          callback(new Error('两次输入密码不一致!'));
      } else {
          callback();
      }
    };
    return {
      adddialogVisible: false,
      updpasdialogVisible: false,
      Data: {
        coMember: {
          Uname: '',
        },
        company: {
          Address: '',
          Name: '',
          Fax: '',
          PostCode: '',
          Email: '',
          ServiceTel: '',
          Tel1:'',
        },
      },
      updFormpas: {
        OldPassword: '',
        NewPassword: '',
        chickPassword: '',
      },
      rules:{
        Address:[{  required: true, message: '请输入地址', trigger: 'blur'}],
        Tel1:[{  required: true, message: '请输入联系人手机号', trigger: 'blur'},
         { validator: validatePhone, trigger: "blur" },
         ],
        ServiceTel:[{  required: true, message: '请输入客服电话', trigger: 'blur'},
         { validator: validatePhoneTwo, trigger: "blur" },
         ],
      },
      updpasformrules: {
        OldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        NewPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
         { validator: validatePasswordNew, trigger: "blur" },
        ],
        chickPassword: [
           { required: true, validator: reCheckPassword, trigger: 'blur' },
          { validator: validatePasswordNew, trigger: "blur" },
        ],
      },

      aStr:["弱", "中","高", "强"],
      strongText:"",
      pwdType1:"password",
      pwdType2:"password",
      pwdType3:"password",
    }
  },
  props: ['uname'],
  computed: {},
  methods: {
    showPwd1(){
      this.pwdType1 === 'password' ? this.pwdType1 = '' : this.pwdType1 = 'password';
      let e=document.getElementById("PassView1");
      this.pwdType1 == '' ? e.setAttribute('style', 'color: #409EFF') : e.setAttribute('style', 'color: #c0c4cc');
    },
    showPwd2(){
      this.pwdType2 === 'password' ? this.pwdType2 = '' : this.pwdType2 = 'password';
      let e=document.getElementById("PassView2");
      this.pwdType2 == '' ? e.setAttribute('style', 'color: #409EFF') : e.setAttribute('style', 'color: #c0c4cc');
    },
    showPwd3(){
      this.pwdType3 === 'password' ? this.pwdType3 = '' : this.pwdType3 = 'password';
      let e=document.getElementById("PassView3");
      this.pwdType3 == '' ? e.setAttribute('style', 'color: #409EFF') : e.setAttribute('style', 'color: #c0c4cc');
    },
    //关闭弹窗后清空表单
    closeDialog(formname) {
      this.$refs[formname].clearValidate()
      this.$refs[formname].resetFields()
    },
    //登录账号管理菜单
    handleCommand(command) {
      switch (command) {
        case 'changePassword':
          this.handleChangePassword()
          break
        case 'openLoginerInfo':
          this.openLoginerInfo()
          break
        case 'logout':
          this.logout()
          break
        default:
          break
      }
    },

    //登出
    logout() {
      removeToken()
      this.$store.commit('user/SET_LOGIN', false)
      this.$router.push('/login')
    },
    //修改个人信息
    openLoginerInfo() {
      UPDATUSER.getCompany(this.Data).then((res) => {
        if (res.status === 'success') {
          this.Data.company = res.content
          this.adddialogVisible = true
        } else {
          this.$message.error('获取失败!')
        }
      })
    },
    //打开修改密码对话框
    handleChangePassword() {
      this.updpasdialogVisible = true;
      this.pwdType1="password";
      let e1=document.getElementById("PassView1");
      e1.setAttribute('style', 'color: #c0c4cc');

      this.pwdType2="password";
      let e2=document.getElementById("PassView2");
      e2.setAttribute('style', 'color: #c0c4cc');

      this.pwdType3="password";
      let e3=document.getElementById("PassView3");
      e3.setAttribute('style', 'color: #c0c4cc');
    },
   
    //修改信息
    postModel() {
      UPDATUSER.updateCompany(this.Data).then((res) => {
        if (res.status === 'success') {
          this.$message.success('修改成功!')
          this.adddialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    //修改密码
    changepas(formName) {
      this.$refs[formName].validate((success) => {
        if(success){

           if(this.strongText!="强"){
            this.$message.error("密码需为8位及以上的大小写字母、数字及特殊符合组合!");
            return false;
          }
          UPDATUSER.changePassword(this.updFormpas).then((res) => {
            if (res.status === 'success') {
              this.$message.success('修改成功!');
              this.updpasdialogVisible = false;
              this.logout();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    //密码强度检测
    checkStrong(val){
      var modes = 0;
      if (val.length < 8) return 0;
      if (/\d/.test(val)) modes++; //数字
      if (/[a-z]/.test(val)) modes++; //小写
      if (/[A-Z]/.test(val)) modes++; //大写 
      if (/\W/.test(val)) modes++; //特殊字符
      return modes;
    },
  },
  watch:{
    "updFormpas.NewPassword":function(val){
      var _self=this;
      var num = _self.checkStrong(val);
      //强度  否则 undefined
      _self.strongText=_self.aStr[num - 1];
      switch(num){
        case 0:
          $("#tips span").css('background', 'green').text('');
          break;
        case 1:
          $("#tips span").css('background', 'yellow').text('').eq(num - 1).css('background', 'red').text(_self.aStr[num - 1]);
          break;
        case 2:
          $("#tips span").css('background', 'green').text('').eq(num - 1).css('background', 'red').text(_self.aStr[num - 1]);
          break;
        case 3:
          $("#tips span").css('background', 'green').text('').eq(num - 1).css('background', 'red').text(_self.aStr[num - 1]);
          break;
        case 4:
          $("#tips span").css('background', 'green').text('').eq(num - 1).css('background', 'red').text(_self.aStr[num - 1]);
          break;
        default:
           $("#tips span").css('background', 'green').text('');
          break;
      }
    },
  },
}
</script>

<style scoped lang="less">
#tips {
  float: left;
  margin: 2px 0 0 0;
}
 
#tips span {
  float: left;
  width: 50px;
  height: 20px;
  color: white;
  background: green;
  margin-right: 2px;
  line-height: 20px;
  text-align: center;
}
.header {
  position: fixed;
  top: 0;
  width: 100vw;
  // min-width: 1000px;
  height: 60px;
  overflow: hidden;
  background-color: #4592eb;
  color: white !important;
  font-size: 18px;
  padding: 0 15px;
  z-index: 1000;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
}
.header-right i {
  cursor: pointer;
  color: white !important;
  // margin-bottom: 4px;
}

.uname {
  color: white !important;
  padding: 0 5px;
  box-sizing: border-box;
}
</style>
